
export const Footer = () => {
  return (
    <div className="footer-menu d-column-flex justify-content-center">
      <div className="row d-column-flex justify-content-center align-items-center">
        <div className="d-flex justify-content-center align-items-center col-12">
          <a href={"/legal/terms-of-service"} target="_blank" className="me-4">
            Terms of Service
          </a>
          <a href={"/legal/privacy-policy"} target="_blank" className="me-4">
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  )
}
